import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { lightTheme, MODULE_THEMES } from '../../Theme';
import { Box, Stack } from '../../ui';
import { Module } from '../../Module';
import { HelpHeader } from '../../Help/HelpHeader';
import { HelpFAQ } from '../../Help/HelpFAQ';
import { TopicGrid } from '../../Help/TopicGrid';
import { kleinBlue } from '@spotify-internal/encore-web';
import { ThemeProvider } from 'styled-components';
import { useDynamicNavBarColor } from '../useDynamicNavBarColor';
import { itemToSearchHit } from '../../Search';
import { useLocale, useT } from '@mrkt/features/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var HelpHomeTemplate = function HelpHomeTemplate(template) {
  var t = useT();
  var locale = useLocale();
  var _template$headline = template.headline,
      headline = _template$headline === void 0 ? t('FRODOR_bddb15', 'Creator Marketing Support', '') : _template$headline,
      frequentlyAskedQuestions = template.frequentlyAskedQuestions,
      faqCategories = template.faqCategories,
      modules = template.modules;

  var allModules = _toConsumableArray(modules || []).filter(function (m) {
    return Boolean(m === null || m === void 0 ? void 0 : m.contentType);
  });

  useDynamicNavBarColor({
    backgroundColor: kleinBlue
  });
  var renderModule = React.useCallback(function (mod) {
    var modProps = _objectSpread({}, mod);

    return /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Module, _objectSpread({}, modProps))
    });
  }, []);

  var modTheme = function modTheme(mod) {
    return _objectSpread(_objectSpread({}, lightTheme), MODULE_THEMES[mod.themeName || ''] || {});
  };

  var faqs = frequentlyAskedQuestions === null || frequentlyAskedQuestions === void 0 ? void 0 : frequentlyAskedQuestions.map(function (item) {
    return itemToSearchHit(item, locale);
  }).filter(Boolean);
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: lightTheme,
    children: /*#__PURE__*/_jsxs(Stack, {
      "data-testid": "help-home-help",
      children: [/*#__PURE__*/_jsx(HelpHeader, {
        headline: headline,
        backgroundColor: kleinBlue
      }), faqs && /*#__PURE__*/_jsx(HelpFAQ, {
        items: faqs
      }), faqCategories && /*#__PURE__*/_jsx(TopicGrid, {
        items: faqCategories
      }), allModules.map(function (mod, idx) {
        return /*#__PURE__*/_jsx(ThemeProvider, {
          theme: modTheme(mod),
          children: /*#__PURE__*/_jsx(Box, {
            children: renderModule(mod)
          })
        }, "".concat(mod.id, "-").concat(idx));
      })]
    })
  });
};